var React = require('react');

function IcArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"2","d":"M11.5 1.5v18M18 14l-6.5 6.5L5 14"}));
}

IcArrowDown.defaultProps = {"width":"24px","height":"24px","fill":"none","viewBox":"0 0 24 24"};

module.exports = IcArrowDown;

IcArrowDown.default = IcArrowDown;
